import { render, staticRenderFns } from "./otc.vue?vue&type=template&id=0e0cbe48&scoped=true&"
import script from "./otc.vue?vue&type=script&lang=js&"
export * from "./otc.vue?vue&type=script&lang=js&"
import style0 from "./otc.vue?vue&type=style&index=0&id=0e0cbe48&prod&lang=scss&"
import style1 from "./otc.vue?vue&type=style&index=1&id=0e0cbe48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0cbe48",
  null
  
)

export default component.exports